export const getTenantCheckboxState = (
  tenantID,
  tenantTeam,
  selectedCallerIds,
) => {
  const selectedFromThisTenant = selectedCallerIds.filter(
    ({ TenantID }) => TenantID === tenantID,
  );

  return {
    indeterminate:
      selectedFromThisTenant.length !== 0 &&
      selectedFromThisTenant.length < tenantTeam.length,
    checked: selectedFromThisTenant.length === tenantTeam.length,
  };
};

export const isTenantFound = (searchValue, tenantName) => {
  const searchValueToLowerCase = searchValue.toLowerCase();
  const tenantNameToLowerCase = tenantName.toLowerCase();
  return tenantNameToLowerCase.includes(searchValueToLowerCase);
};

export const getFilteredTeam = (tenantTeam, searchValue) => {
  return tenantTeam.filter(({ CallerName }) => {
    const searchValueToLowerCase = searchValue.toLowerCase();
    const callerNameToLowerCase = CallerName.toLowerCase();
    return callerNameToLowerCase.includes(searchValueToLowerCase);
  });
};

export const getFilteredTeams = (teams, searchValue) => {
  return teams.flatMap(({ TenantName, TenantTeam }) => {
    const matches = [];

    if (isTenantFound(searchValue, TenantName)) {
      matches.push(TenantName);
    }

    matches.push(...getFilteredTeam(TenantTeam, searchValue));

    return matches;
  });
};
